import React from "react";
import ModalCloseButton from "atoms/buttons/modal-close-button";
import { CurrentConversationProvider } from "utilities/atoms/conversations/current-conversation/current-conversation-provider";
import { NotebookConversationAtom } from "utilities/atoms/conversations/current-conversation/conversation-atoms";
import { t } from "utilities/localization-utils";
import useToggleNotebookChatPanel from "./use-toggle-notebook-chat-panel";
import ChatPanelContent from "organisms/panels/bookview-tab-panels/chat-panel-content";
import { ChatContextType } from "constants/chat-context-types";
import Icon from "atoms/icons/icon";
import useNotebookChatContext from "./use-notebook-chat-context";
import {
    EventsProvider,
    SearchSource,
} from "utilities/contexts/events/events-provider";

const CHAT_PANEL_CLASS_NAME = "c-notebook-chat-panel";
const NotebookChatPanelContent: React.FC = () => {
    const { showPanel, closePanel } = useToggleNotebookChatPanel();
    const shouldShow = showPanel ? "-open" : "-closed";

    const {
        notebookChatContext: context,
        notebookApplicationContext: applicationContext,
    } = useNotebookChatContext();

    const contextList = [
        context.notebookName,
        context.pageName,
        context.block ? (
            <>
                <Icon type={context.block.icon} />
                <span>&nbsp;{context.block.label}</span>
            </>
        ) : null,
    ].filter((entry) => entry !== null);

    return (
        <div className={`${CHAT_PANEL_CLASS_NAME} ${shouldShow}`}>
            <header className={`${CHAT_PANEL_CLASS_NAME}__header`}>
                <div className={`${CHAT_PANEL_CLASS_NAME}__heading`}>
                    <div className={`${CHAT_PANEL_CLASS_NAME}__title`}>
                        <span>{t("casi")}</span>

                        <ModalCloseButton onClick={closePanel} />
                    </div>
                </div>
            </header>
            <div className={`${CHAT_PANEL_CLASS_NAME}__body`}>
                <ChatPanelContent
                    applicationContext={applicationContext}
                    context={ChatContextType.Notebooks}
                    contextList={contextList}
                />
            </div>
        </div>
    );
};

// Wrap the content component with the provider so we can use the hook
const NotebookChatPanel: React.FC = () => (
    <EventsProvider source={SearchSource.Notebooks}>
        <CurrentConversationProvider atom={NotebookConversationAtom}>
            <NotebookChatPanelContent />
        </CurrentConversationProvider>
    </EventsProvider>
);

export default NotebookChatPanel;
